import dailyTipsService from "@/services/dailyTipsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await dailyTipsService.create(formData);
      dispatch(
        "common/showSuccess",
        "Tagestipp wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Tagestipp konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, formData) {
    try {
      const res = await dailyTipsService.findAll(formData);
      commit("setAllFeatureTags", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Tagestippen konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await dailyTipsService.delete({ id });
      dispatch(
        "common/showSuccess",
        "Tagestipp wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Tagestipp konnten nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAllFeatureTags(state, object) {
    state.all = object;
  },
  setSingleFeatureTag(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
